module.exports = __webpack_public_path__ + "static/img/12.5813020.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/4/eng/12.png
// module id = b87E
// module chunks = 0